import {Box, Text} from "theme-ui";
import {KeyboardArrowRight as Arrow} from "@styled-icons/material-twotone/KeyboardArrowRight";
import React from "react";
import {Inline} from "@bedrock-layout/inline";

function BreadCrumbs() {
    return (
        <Box variant="layout.header.bread-crumbs">
            <Inline gutter="md" variant="breadcrumbs">
                <Box py={2} px={5} width="55px" />
                {/*<Arrow height={20} />*/}
                <Box py={2} px={5} width="145px" />
                {/*<Arrow height={20} />*/}
                <Box py={2} px={4} width="20px" />
            </Inline>
        </Box>

    )
}

export default BreadCrumbs;